import { Stack, TextInput, Select } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import type { DataSource } from "@bi-studio/shared/lib";

interface ReportGeneralConfigProps {
    form: UseFormReturnType<any>;
    isSaving: boolean;
    dataSources: DataSource[];
}

export function ReportGeneralConfig({
    form,
    isSaving,
    dataSources,
}: ReportGeneralConfigProps) {
    return (
        <Stack gap="md">
            <TextInput
                label="Report Name"
                placeholder="Sales Report"
                disabled={isSaving}
                required
                {...form.getInputProps("name")}
            />

            <TextInput
                label="Description"
                placeholder="Report description"
                disabled={isSaving}
                {...form.getInputProps("description")}
            />

            <Select
                label="Data Source"
                value={form.values.dataSourceId}
                onChange={(val) => form.setFieldValue("dataSourceId", val || "")}
                data={dataSources.map((ds) => ({
                    value: ds.id,
                    label: `${ds.name} (${ds.type})`
                }))}
                disabled={isSaving}
                required
                placeholder="Select a data source"
                error={form.errors.dataSourceId}
            />
        </Stack>
    );
}
